import { stickShapeConfigRegistry } from './registerShapes';

// PORT TYPES

export const PORT_TYPE = {
  SOURCE: 'source',
  DRAIN: 'drain',
  GATE: 'gate',
};

const PORT_NAME_TO_TYPE = {
  G: PORT_TYPE.GATE,
  S: PORT_TYPE.SOURCE,
  D: PORT_TYPE.DRAIN,
};


// VALID RULES

export const isValidPortOverlap = (t1, t2) => {
  const valid = {
    'source|source': true,
    'source|drain': true,
    'drain|source': true,
    'drain|drain': true,
    'gate|gate': true,
    'gate|source': false,
    'gate|drain': false,
    'source|gate': false,
    'drain|gate': false,
  };

  const result = valid[`${t1}|${t2}`] || false;
  return result;
};

const getPortType = (name) => PORT_NAME_TO_TYPE[name] || null;

//  GET PORT CELLS (FIXED - uses VIEW STATE)

const getPortCellsForVertex = (vertex, graph) => {
  const model = graph.getModel();
  const ports = [];

  const childCount = model.getChildCount(vertex);

  for (let i = 0; i < childCount; i++) {
    const child = model.getChildAt(vertex, i);
    const style = child.style || '';

    if (!style.includes('shape=ellipse') || !child.connectable) continue;

    const portName = child.name || '';
    const portType = getPortType(portName);

    if (!portType) continue;

    // 🔥 FIX: USE VIEW STATE (NOT GEOMETRY)
    const state = graph.view.getState(child);
    if (!state) continue;

    const x = state.getCenterX();
    const y = state.getCenterY();

    ports.push({
      cell: child,
      portName,
      portType,
      x,
      y,
    });
  }

  return ports;
};

// OVERLAP CHECK

const arePortsOverlapping = (p1, p2, tolerance = 5) => {
  const dx = p1.x - p2.x;
  const dy = p1.y - p2.y;
  const dist = Math.sqrt(dx * dx + dy * dy);

  const result = dist <= tolerance;

  return result;
};


//  PREVENT DUPLICATE
 
const portConnectionExists = (graph, p1, p2) => {
  const model = graph.getModel();
  const edges = graph.getEdges(p1);

  return edges.some(edge => {
    const s = model.getTerminal(edge, true);
    const t = model.getTerminal(edge, false);
    return (
      (s === p1 && t === p2) ||
      (s === p2 && t === p1)
    );
  });
};


export const processPortOverlaps = (graph, tolerance = 5 , edgeColor = "#38befe", edgeWidth = "2", isDarkMode = false) => {

  const model = graph.getModel();
  const parent = graph.getDefaultParent();
  const vertices = graph.getChildVertices(parent);

  let created = 0;

  for (let i = 0; i < vertices.length; i++) {
    for (let j = i + 1; j < vertices.length; j++) {

      const v1 = vertices[i];
      const v2 = vertices[j];

      const ports1 = getPortCellsForVertex(v1, graph);
      const ports2 = getPortCellsForVertex(v2, graph);

      ports1.forEach(p1 => {
        ports2.forEach(p2 => {

          // 1. overlap
          if (!arePortsOverlapping(p1, p2, tolerance)) return;

          // 2. rule
          if (!isValidPortOverlap(p1.portType, p2.portType)) {
            console.log("❌ Invalid connection blocked");
            return;
          }

          // 3. duplicate
          if (portConnectionExists(graph, p1.cell, p2.cell)) {
            console.log("⚠️ Already connected");
            return;
          }

          // 4. create edge
          const edge = graph.connectionHandler.insertEdge(
            graph.getDefaultParent(),
            null,
            '',
            p1.cell,
            p2.cell
          );

          if (edge) {
            const model = graph.getModel();

            const edgeStrokeColor = edgeColor;
            const strokeWidth = edgeWidth;
            const fontColor = isDarkMode ? '#ffffff' : '#000000';

            let style = model.getStyle(edge) || "";

            // strokeColor
            if (style.includes("strokeColor=")) {
              style = style.replace(/strokeColor=[^;]*/,`strokeColor=${edgeStrokeColor}`);
            } else {
              style += `;strokeColor=${edgeStrokeColor}`;
            }

            // fontColor
            if (style.includes("fontColor=")) {
              style = style.replace(/fontColor=[^;]*/,`fontColor=${fontColor}`);
            } else {
              style += `;fontColor=${fontColor}`;
            }

            // strokeWidth
            if (style.includes("strokeWidth=")) {
              style = style.replace(/strokeWidth=[^;]*/,`strokeWidth=${strokeWidth}`);
            } else {
              style += `;strokeWidth=${strokeWidth}`;
            }

            // edge style
            if (!style.includes("edgeStyle=")) {
              style += `;edgeStyle=wireEdgeStyle`;
            }

            model.setStyle(edge, style);

            // IMPORTANT
            graph.view.invalidate(edge);
            graph.view.validate();

            created++;
          }

        });
      });
    }
  }

  return created;
};
